<template>
  <div>
    <VMenu
      v-if="getLogged"
      open-on-hover
      offset-y
      bottom
    >
      <template #activator="{ on, attrs }">
        <VBtn
          icon
          v-bind="attrs"
          v-on="on"
        >
          <VIcon>mdi-account-circle</VIcon>
        </VBtn>
      </template>
      <VList>
        <slot name="UserActions" />

        <VListItem @click="resetPassword">
          <VListItemTitle>{{ $t('auth.forget_password.reset_password') }}</VListItemTitle>
          <VIcon class="ml-2">
            mdi-lock-reset
          </VIcon>
        </VListItem>
        <VListItem @click="logout">
          <VListItemTitle>{{ $t('auth.logout.logout') }}</VListItemTitle>
          <VIcon class="ml-2">
            mdi-logout
          </VIcon>
        </VListItem>
      </VList>
    </VMenu>
    <VBtn
      v-else
      class="mr-3"
      outlined
      color="black"
      :to="{ name: 'Login' }"
    >
      {{ $t('auth.login.login') }}
    </VBtn>
    <ResetPasswordDialog ref="resetPasswordDialog"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  components: {
    ResetPasswordDialog: () => import('@/app/Auth/comp/ResetPasswordDialog.vue')
  },
  computed: {
    ...mapGetters('Auth', ['getUser','getLogged']),
  },
  methods: {
    logout () {
      this.storeApiDispatch('Auth/Auth_logout')
    },
    async resetPassword () {
      await this.$refs.resetPasswordDialog.openDialog();
    }
  }
}
</script>
